import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller, useFieldArray } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import Button from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import { useStockAdjustmentApi } from '../../../../store/api/hooks/stockAdjustmentApiHook';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import { getSelectedOption, showDate } from '../../../../_common/functions';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../../_common/constant';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { useUserSelector } from '../../../../store/selectors/userSelector';


interface StockAdjFormProps {
    _ref?: any;
    editID?: any;
    onCreate?: () => void
    onCancel?: () => void
}
type partType = {
    id?: number;
    partDetails?: any;
    partCode?: string;
    partName?: string;
    stockOnHand?: number;
    qty?: any;
    cost?: number;
}

type FormValues = {
    stockAdjustmentID?: number;
    stockAdjustmentSerialNo: string;
    stockAdjustmentDate: string;
    operatorID: any;
    facilityID: any;
    subFacilityID: any;
    stockAdjustmentNote: string;
    adjustmentDetailsList: any[];
    parts: partType[];
};
const CreateStockAdjustment: React.FC<StockAdjFormProps> = ({_ref, editID, onCreate = () => { }, onCancel = () => { } }) => {
    const { control, register, handleSubmit, formState: { errors }, reset , setValue, watch} = useForm<FormValues>();
    const stockAPI = useStockAdjustmentApi();
    const facilityApi: any = useFacilitiesApi();
    const assetApi: any = useAssetsApi();
    const { showLoader, hideLoader } = useAppLoader();
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [subFacilityOptions, setSubFacilityOptions] = useState<any>([]);
    const [vendorlist, setvendorList] = useState<any>([]);
    const [editData, setEditData] = useState<any>(null);

    const user:any = useUserSelector();

    const facilityWatch = watch('facilityID');

    const spearPartsAPI = useSpearPartsApi();

    const { fields: parts, append, update, prepend, remove, swap, move, insert } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: "parts", // unique name for your Field Array
    });


    const getNewCode = () => {
        stockAPI.getStockAdjustmentCode({},
            (resp: any) => {
                console.log("New Code", resp)
            }, (error: any) => {
                console.log("New Code Error", error)
            }
        )
    }
    

    const getfacilitylist = () => {
        const payload = {
            pageSize: 100,
            pageNumber: 1,
        };
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = resp.facilityList.map((facilist: any) => {
                    return {
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                    };
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const getVenderList = () => {
        const payload = {};
        assetApi.GetvenderList(
            payload,
            (resp: any) => {
                let deptlist: any = resp.vendorList.map((facilist: any) => {
                    return {
                        label: facilist.name,
                        value: facilist.vendorID,
                    }
                });
                setvendorList(deptlist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
   

    const onSubmit: SubmitHandler<FormValues> = data => {
        console.log(data);
        let payload:any = {           
            facilityID: data.facilityID.value,
            subFacilityID: data.subFacilityID?.value,
            stockAdjustmentNote: data.stockAdjustmentNote,
            operatorID:user.userID,
            stockAdjustmentDate: showDate(new Date(), DATE_FORMAT),
            adjustmentDetailsList: data.parts.map((part: any) => {
                return {
                    "partsID": part.partDetails.partsID,
                    "stockOnHand": part.partDetails.currenctStock,
                    "adjustedQuantity": part.qty,
                    "partsCostRate": part.partDetails.costPerUnit,
                    "partsTotalAmount": part.cost,
                    "partsTotalAmountLocal": part.cost,
                }
            })
           
          }

          if (editID) {
            payload['stockAdjustmentID'] = editID;
          }

          showLoader();
          stockAPI.saveStockAdjustment(payload, (resp: any) => {
            onCreate();
            onCancel();
            console.log(resp, "Submited resp")
            toast.success(resp?.message)
            formReset();
            hideLoader();
      
          }, (error: any) => {
            console.log('error =>', error);
            hideLoader();
            toast.error(error);
          });
    };

    useEffect(() => {
        if(facilityWatch){
            setValue('subFacilityID', null);
            const payload = {
                facilityID: facilityWatch.value
            }
            facilityApi.getSubFacilityList(
                payload,
                (resp: any) => {
                    setSubFacilityOptions(resp?.subFacilityList?.map((facilist: any) => {
                        return {
                            label: `${facilist.subFacilityTypeName} - ${facilist.no}`,
                            value: facilist.subFacilityID,
                        };
                    }));
                },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    }, [facilityWatch]);

    useEffect(() => {
        //getNewCode();
        getfacilitylist();
        getVenderList();
    }, []);
    useEffect(() => {
        if(editID){
            stockAPI.getStockAdjustmentByID({PartsStockAdjustmentID:editID}, (resp: any) => {
                console.log("Edit Data", resp)
                setEditData(resp);
            }, (error: any) => {
                console.log("Edit Data Error", error)
            })
        }
    }, [editID]);


    const formReset = () => {
        reset({
           
            stockAdjustmentSerialNo: "",
            stockAdjustmentDate: "",
            operatorID: "",
            facilityID: "",
            stockAdjustmentNote: "",
            adjustmentDetailsList: [],
        });
        remove();

    }

    useEffect(() => {
        if (editData == null) {
            formReset();
        }
    }, [editData]);

    useEffect(() => {
        if (editData) {
            reset({
            
                stockAdjustmentSerialNo: editData.stockAdjustmentSerialNo,
                stockAdjustmentDate: showDate(editData.stockAdjustmentDate, DATE_FORMAT),
                operatorID: getSelectedOption(editData.operatorID, vendorlist),
                facilityID: getSelectedOption(editData.facilityID, facilityoption),
                subFacilityID: getSelectedOption(editData.subFacilityID, subFacilityOptions),
                stockAdjustmentNote: editData.stockAdjustmentNote,
                parts: editData?.stockAdjustmentList.map((part: any) => {
                    return {
                        partCode: part.partsCode,
                        partName: part.partName,
                        stockOnHand: part.stockOnHand,
                        qty: part.stockOnHand,
                        cost: part.partsTotalAmount,
                        partDetails: {...part, sparePartsName: part.partName, currenctStock: part.stockOnHand, costPerUnit: part.partsCostRate, }
                    }  
                }
                )
            });
        }
    }, [editData, facilityoption, vendorlist]);

    useEffect(() => {
        if (_ref?.current) {
          _ref.current.reset = formReset;
        }
      }, [_ref]);



    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref}>
            <div className='pt-4'>
                {
                    editData && <>
                        <div className="grid grid-cols-3 gap-2">
                            <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Adjustment No</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{editData?.stockAdjustmentSerialNo}</p>
                            </div>
                            <div className='bg-green-50 py-2 px-3 '>
                                <h6 className='text-[0.813rem] font-semibold'>Adjusted By</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{editData?.addedByName}</p>
                            </div>
                            <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Date and Time</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{showDate(editData?.stockAdjustmentDate, DATE_TIME_FORMAT)}</p>
                            </div>
                        </div>
                    </>
                }

                {/* <div className="grid grid-cols-2 gap-2"> */}
                    <Controller
                        name='facilityID'
                        control={control}
                        rules={{ required: 'Facility is required' }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Select Facility'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Choose Facility'
                                options={facilityoption}
                                className='mb-0'
                            />
                        )}
                    />
                    <Controller
                        name='subFacilityID'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Select Sub Facility'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Facility'
                                options={subFacilityOptions}
                                className='mb-0'
                            />
                        )}
                    />
                    <div className='flex justify-between items-center my-6'>
                        <h4 className='font-semibold text-[0.938rem] uppercase'>PART DETAILS</h4>
                        <Button theme='secondary' size='sm' className='text-[0.75rem]' onClick={()=>{append({})}}>Add Part</Button>
                    </div>

                <div className='rounded-md border border-gray-300'>
                    <div className='grid grid-cols-12 gap-1 bg-gray-100'>
                        <div className='col-span-3 px-2 leading-10 '>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Part Code</label>
                        </div>
                        <div className='col-span-3 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Part Name</label>
                        </div>
                        <div className='col-span-2 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Stock on Hand</label>
                        </div>
                        <div className='col-span-2 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Adjusted Qty</label>
                        </div>
                        <div className='col-span-2 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Adjusted Cost</label>
                        </div>
                    </div>
                    {parts.map((part, index) => (
                        <div className='grid grid-cols-12 gap-1 text-slate-800' key={part.id}>
                            <div className='col-span-3 px-2 leading-10 flex items-center'>
                                <SelectBox
                                    className='!my-0 w-full'
                                    size='sm'
                                    async={true}
                                    value={part.partCode ? { label: part.partCode, value: part.partDetails?.id } as any : null}
                                    onChange={(option) => {
                                        update(index, {
                                            ...parts[index],
                                            partCode: option?.partDetails.partsCode,
                                            partDetails: option?.partDetails,
                                            qty: option?.partDetails?.currenctStock,
                                            cost: option?.partDetails?.currenctStock * option?.partDetails?.costPerUnit
                                        });
                                    }}
                                    placeholder='search part here'
                                    asyncLoadOptions={(value: string) => {
                                        return new Promise((resolve, reject) => {
                                            spearPartsAPI.getSpearPartsList({
                                                pageSize: 20,
                                                pageNumber: 1,
                                                searchKey: value
                                            }, (data: any) => {
                                                console.log("Part Data", data)
                                                resolve(data.sparePartsList.map((part: any) => {
                                                    return {
                                                        label: part.sparePartsName + ` (${part.partsCode})`,
                                                        value: part.partsID,
                                                        partDetails: part
                                                    }
                                                }))
                                            }, (error: any) => {
                                                reject(error);
                                            });
                                        });
                                    }}
                                />
                            </div>
                            <div className='col-span-3 px-2 leading-10 flex items-center'>
                                <label className='text-[0.75rem] font-normal'>{part?.partDetails?.sparePartsName}</label>
                            </div>
                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                <label className='text-[0.75rem] font-normal text-center w-full'>{part?.partDetails?.currenctStock}</label>
                            </div>
                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                    {part.qty ? <Input
                                    size='sm'
                                    className='!my-0'
                                    type='number'
                                    value={part.qty}
                                    onChange={(e) => update(index, {
                                         ...parts[index],
                                          qty: e.target.value , 
                                          cost: Number(e.target.value) * part?.partDetails?.costPerUnit})}
                                /> : <p className='text-center w-full'>-</p>}
                                
                            </div>
                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                <label className='text-[0.75rem] font-normal text-center w-full'>{part?.cost?'$':'-'}{part?.cost}</label>
                            </div>
                        </div>
                    ))}
                </div>
                    {/* <Controller
                        name='operatorID'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Select Vendor'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Choose Vendor'
                                options={vendorlist}
                                className='mb-0'
                            />
                        )}
                    />
                </div> */}
                {/* <Controller
                    name='drop'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <SelectBox
                            label='Select Sub Facility'
                            value={value}
                            onChange={onChange}
                            required
                            placeholder='Western Regional'
                            options={[]}
                            className='mb-0'
                        />
                    )}
                /> */}

                {/* <h4 className='font-semibold text-[0.938rem] py-4 uppercase'>Ref Cycle Count</h4>
                <div className="ag-theme-alpine h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData} // Pass rowData
                        pagination={false}
                        domLayout="autoHeight"
                    />
                </div> */}

                <Controller
                    name='stockAdjustmentNote'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <Teaxtarea
                            label='Notes'
                            value={value}
                            onChange={onChange}
                            placeholder='Write Your Notes'
                        />
                    )}
                />

                <hr className='border-gray-900 my-6' />
            </div>
            <div className='flex justify-end gap-2'>
                <Button type='submit' working={false}>Save</Button>
                <Button theme='secondary' onClick={()=>{
                    onCancel();
                    formReset();
                }}>Cancel</Button>
            </div>

            {/* <input id="assetName" {...register('assetName', { required: true })} />
            {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div> */}

            {/* <button type="submit">Create Asset</button> */}
        </form>
    );
};

export default CreateStockAdjustment;